// routes
import { PATH_MasterUser } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';
import AppCache from '../../../services/appcache';
// --------------------------------------------------------------------------------------------------------

const icon = (name) => (<SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />);

const ICONS = {
    dataUpload: icon('ic_dataupload'),
    dataMapping: icon('ic_mapping'),
    enablereupload: icon('ic_reupload'),
    master: icon('ic_master'),
    reprocess: icon('ic_reprocess'),
    topic: icon('ic_topic'),
    cart: icon('category'),
    tags: icon('tag')
};

const userDetails = AppCache.GetUserLoginDetails();
const hasZylemFranchise = userDetails?.Franchise?.split(',')
    .some(f => f.trim().toUpperCase() === 'ETHICON' || f.trim().toUpperCase() === 'ENDO');

const navConfig = [
    //   GENERAL
    //   ----------------------------------------------------------------------
    {
        items: [
            {
                title: 'Masters', path: PATH_MasterUser.master.root, icon: ICONS.master,
                children: [
                    { title: 'Distributor', path: PATH_MasterUser.master.distributor },
                    { title: 'Products', path: PATH_MasterUser.master.product },
                    { title: 'ECP Product', path: PATH_MasterUser.master.ecpproduct },
                    { title: 'Standard Price', path: PATH_MasterUser.master.standardpricemaster },
                    { title: 'Accounts', path: PATH_MasterUser.master.account },
                    { title: 'Area Tree', path: PATH_MasterUser.master.areatree },
                    { title: 'Surgeons', path: PATH_MasterUser.master.surgeon },
                    { title: 'Employee', path: PATH_MasterUser.master.empmaster },
                    { title: 'Territory', path: PATH_MasterUser.master.territory },
                    { title: 'Employee Territory', path: PATH_MasterUser.master.empterritory },
                    { title: 'Territory Management', path: PATH_MasterUser.master.accountterritory },
                    { title: 'Branch Secretary Region', path: PATH_MasterUser.master.empregion },
                    { title: 'Distributor Territory', path: PATH_MasterUser.master.distributorterritory },
                    { title: 'Territory Hierarchy', path: PATH_MasterUser.master.territoryhierarchy },
                    { title: 'Organization Group ', path: PATH_MasterUser.master.orggroupdefinition },
                    { title: 'Dealer Agreement', path: PATH_MasterUser.master.dealeragreementexpiry },
                    { title: 'Dealer Rating ', path: PATH_MasterUser.master.dealerrating },
                    { title: 'Distributor Billing Software', path: PATH_MasterUser.master.distributorbillingsoftware },
                    { title: 'Customer', path: PATH_MasterUser.master.customers },
                    { title: 'Customer Account', path: PATH_MasterUser.master.customeraccount },
                ],
            },
            {
                title: 'Allied Master', path: PATH_MasterUser.alliedmaster.root, icon: ICONS.master,
                children: [
                    { title: 'Distributor Group', path: PATH_MasterUser.alliedmaster.distributorgroup },
                    { title: 'UOM', path: PATH_MasterUser.alliedmaster.uom },
                    { title: 'Franchise', path: PATH_MasterUser.alliedmaster.franchise },
                    { title: 'Sub Franchise', path: PATH_MasterUser.alliedmaster.subfranchise },
                    { title: 'Product Group', path: PATH_MasterUser.alliedmaster.productgroup },
                    { title: 'Product category', path: PATH_MasterUser.alliedmaster.productcategory },
                    { title: 'Product Brand', path: PATH_MasterUser.alliedmaster.productbrand },
                    { title: 'Product Line', path: PATH_MasterUser.alliedmaster.productline },
                    { title: 'Account Group', path: PATH_MasterUser.alliedmaster.accountgroup },
                    { title: 'Account Type', path: PATH_MasterUser.alliedmaster.accounttype },
                    { title: 'Account Classification', path: PATH_MasterUser.alliedmaster.accountclassification },
                    { title: 'Account Segmentation', path: PATH_MasterUser.alliedmaster.accountsegmentation },
                    { title: 'Account Category', path: PATH_MasterUser.alliedmaster.accountcategory },
                    { title: 'Surgeon Contact Type', path: PATH_MasterUser.alliedmaster.surgeoncontacttype },
                    { title: 'Surgeon Sub Contact Type', path: PATH_MasterUser.alliedmaster.surgeonsubcontacttype },
                    { title: 'City Tier', path: PATH_MasterUser.alliedmaster.citytier },
                    { title: 'Employee Level', path: PATH_MasterUser.alliedmaster.emplevel },
                    { title: 'Specialist', path: PATH_MasterUser.alliedmaster.specialist },
                    { title: 'Bravo Hierarchy', path: PATH_MasterUser.alliedmaster.bravohierarchy },
                ],
            },
            { title: 'Data Upload Status', path: PATH_MasterUser.dataUploadApprove, icon: ICONS.dataUpload },
            ...(hasZylemFranchise ? [
                { title: 'Reload Zylem Data', path: PATH_MasterUser.reloadzylemdata, icon: ICONS.reprocess },
                { title: 'Data Mapping', path: PATH_MasterUser.datamapping, icon: ICONS.dataMapping }
            ] : []),
            { title: 'Enable Reupload', path: PATH_MasterUser.enablereupload, icon: ICONS.enablereupload },
            { title: 'Configuration', path: PATH_MasterUser.configuration, icon: ICONS.master },
            // { title: 'System Configuration ', path: PATH_MasterUser.cutoffdatepage, icon: ICONS.master },
            { title: 'System Configuration ', path: PATH_MasterUser.franchisewisecutoff, icon: ICONS.master },
            { title: 'Help Topics', path: PATH_MasterUser.helptopics, icon: ICONS.topic },
            { title: 'Help Category', path: PATH_MasterUser.helpcategory, icon: ICONS.cart },
            { title: 'Sub Category', path: PATH_MasterUser.subcategory, icon: ICONS.enablereupload },
            { title: 'Tags', path: PATH_MasterUser.tags, icon: ICONS.tags },
        ],
    }
];

export default navConfig;